function helperStringLowerCase (str) {
  return str.toLowerCase()
}

module.exports = helperStringLowerCase



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperStringLowerCase.js
// module id = 493
// module chunks = 75